import { Box } from "@mui/material";
import { DiscountBanner } from "../../banner/discountBanner";
import { Login } from "./login";
import { updateDocumentTitle } from "../../../helpers/documentHelper";
import { useTranslation } from "react-i18next";
import { BreadcrumbsBar } from "../../breadcrumbs/breadcrumbsBar";
import { LoginRoute } from "../../../routes/allRoutes";

export function LoginPage() {
    const { t } = useTranslation('account');
    updateDocumentTitle(t('login'));
    return (
        <Box>
            <BreadcrumbsBar paths={[{ path: LoginRoute }]} />
            <Login />
        </Box>
    );
}